import { Component, Inject, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade, CustomerAccountsFacade } from '@ridango/components';
import { BaseComponent, AuthService } from '@ridango/core';
import { AccountSelectorDialogComponent } from './account-selector-dialog/account-selector-dialog.component';
import { take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-account-selector',
    templateUrl: './account-selector.component.html',
    styleUrls: ['./account-selector.component.scss']
})
export class AccountSelectorComponent extends BaseComponent implements OnInit {
    assetsPath$ = this.applicationFacade.assetsPath$;
    accountsWithDisplayData$ = this.customerAccountsFacade.accountsWithDisplayData$;
    selectedAccountWithDisplayData$ = this.customerAccountsFacade.selectedAccountWithDisplayData$;
    uiState$ = this.customerAccountsFacade.accountSelectorUIState$;
    allAccountDataLoading$ = this.customerAccountsFacade.allAccountDataLoading$;
    locale = this.translate.currentLang;
    isAuthenticated$: Observable<boolean> = of(false);

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade,
        private customerAccountsFacade: CustomerAccountsFacade,
        private dialog: MatDialog,
        private translate: TranslateService,
        private authService: AuthService,
        private vcr: ViewContainerRef
    ) {
        super();
    }

    ngOnInit(): void {
        const authStatus = this.authService.getLoginStatus();
        this.isAuthenticated$ = of(authStatus);
        if (authStatus) {
            this.customerAccountsFacade.fetchCustomerAccounts();
        }
    }

    onAccountChange(accountId: string): void {
        this.customerAccountsFacade.selectCustomerAccount(accountId);
    }

    trackById(_index: number, item: { id: string }): string {
        return item.id;
    }

    openAccountDialog(): void {
        const dialogRef = this.dialog.open(AccountSelectorDialogComponent, {
            panelClass: 'account-selector-dialog-panel',
            viewContainerRef: this.vcr
        });

        dialogRef
            .afterClosed()
            .pipe(take(1))
            .subscribe((result) => {
                if (result) {
                    this.onAccountChange(result);
                }
            });
    }
}
